import { FC, useMemo } from "react"
import { DLMSiteInspection } from "../_models"
import { DetailCard, DetailItem, DetailLabelKeysToCells } from "../../../../components/layout"
import { PageViewLink } from "../../../../components/widgets"

type Props = {
  details: DLMSiteInspection
}


const DLM_SITEINSPECTION_FIELDS = {
  refNo: 'Reference No'
}

const DLM_SITE_DETAILS_COMMON_FIELDS = {
  projectName: 'Project Name',
  projectLocation: 'Project Location',
  installerName: 'Installer Company',
  companyName: 'Company Name',
  planNo: 'Plan No',    
}

const DLMSiteInspectionDetailsCard: FC<Props> = ({details}) => {

  const { company, applicationCertificate, siteApplication } = useMemo(() => {        
    if (! details) return { company: null, applicationCertificate : null, siteApplication: null};
    const company = details?.company && details.company?.id && details.company.id > 0 ? details.company : null;
    const applicationCertificate = details?.applicationCertificate && details.applicationCertificate?.id && details.applicationCertificate.id > 0 ? details.applicationCertificate : null;
    const siteApplication = details?.siteApplication && details.siteApplication?.id && details.siteApplication.id > 0 ? details.siteApplication : null;

    return { company, applicationCertificate, siteApplication };
  }, [details]);

  return(
  <>
  <div className="d-flex flex-row flex-wrap gap-6 mb-4">
    <DetailCard cardTitle="Details">            
      {DetailLabelKeysToCells(DLM_SITEINSPECTION_FIELDS, details)}            
      { (siteApplication !== null) &&
      <>
      {DetailLabelKeysToCells(DLM_SITE_DETAILS_COMMON_FIELDS, siteApplication)}            
      </>
      }
      { (company !== null) &&
      <DetailItem labelText="Company">
        {company.name}
        &nbsp;
        <PageViewLink id={company.id} pageType="company">(view)</PageViewLink>
      </DetailItem>
      }
      { (applicationCertificate !== null) &&
      <DetailItem labelText="CoC No.">
        {applicationCertificate.cocNumber}
        &nbsp;
        <PageViewLink id={applicationCertificate.id} pageType="certificate">(view)</PageViewLink>
      </DetailItem>
      }            
    </DetailCard>
  </div>
  </>
  )
}

export { DLMSiteInspectionDetailsCard }